import { render, staticRenderFns } from "./DemandServiceTaskItem.vue?vue&type=template&id=3755f6ae&scoped=true&"
import script from "./DemandServiceTaskItem.vue?vue&type=script&lang=js&"
export * from "./DemandServiceTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./DemandServiceTaskItem.vue?vue&type=style&index=0&id=3755f6ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755f6ae",
  null
  
)

export default component.exports